<template>
  <div class="light" :class="{ disabled: isBuildingGIF }">
    <div class="title" v-html="$t('light.title')"></div>
    <div class="play-panel">
      <i
        v-if="isPlaying"
        class="paly iconfont iconstop-o"
        @click="isPlaying = !isPlaying"
      />
      <i
        v-else
        class="stop iconfont iconplay-o"
        @click="isPlaying = !isPlaying"
      />
    </div>
    <div class="control-panel">
      <div class="left">
        <a-radio-group
          :value="profile.lightIndex"
          size="large"
          @change="onLightIndexSelect"
          v-visible="!isPlaying"
        >
          <a-radio-button :value="4"> {{ $t("light.name") }} 1 </a-radio-button>
          <a-radio-button :value="5"> {{ $t("light.name") }} 2 </a-radio-button>
          <a-radio-button :value="6"> {{ $t("light.name") }} 3 </a-radio-button>
        </a-radio-group>
      </div>
      <div class="brightness" v-if="false">
        <i class="iconfont iconbrightness" />
        {{ $t("dark") }}
        <a-slider
          class="slider"
          v-model="brightness"
          :min="1"
          :max="10"
          @change="saved = false"
        />
        {{ $t("bright") }}
      </div>
      <div class="speed">
        <i class="iconfont iconlightning" />
        {{ $t("slow") }}
        <a-slider
          class="slider"
          v-model="speed"
          :min="11"
          :max="16"
          :tip-formatter="(value) => value - 10"
          :tooltipVisible="false"
        />
        {{ $t("fast") }}
      </div>
      <div class="right"></div>
    </div>
    <div class="light-panel">
      <div class="remove">
        <div class="remove-hover">
          <i
            class="close iconfont iconclose"
            v-if="frameLength > 1 && !isPlaying"
            @click="removeFrame"
          />
          <i
            class="reset iconfont iconreset"
            v-if="frameLength > 1 && !isPlaying"
            @click="removeAllFrame"
          />
          <i
            class="iconfont iconminus-o"
            v-visible="frameLength > 1 && !isPlaying"
          />
        </div>
      </div>
      <c-led-strip
        class="lights"
        :isPlaying="isPlaying"
        :brightness="brightness"
        :speed="speed"
        :frames="frames"
        :frameIndex="frameIndex"
        :selectedIndexes="selectedIndexes"
        @led-click="onLEDClick"
        @led-click-right="onLEDClickRight"
      />
      <div class="add" v-show="frameLength < maxFrameLength && !isPlaying">
        <i class="iconfont iconplus-o" @click="addFrame" />
        <span>
          {{ $t("light.add") }}
        </span>
      </div>
    </div>
    <div class="page-panel" v-visible="frameLength > 1 && !isPlaying">
      <i
        class="prev iconfont iconleft"
        v-visible="frameNow > 1 && !isPlaying"
        @click="prevFrame"
      />
      <div class="page">
        01
      </div>
      <a-slider
        class="page-slider"
        :value="frameNow"
        @change="changeFrame"
        :min="1"
        :max="frameLength"
        :tipFormatter="null"
      />
      <div class="page-now">
        {{ frameNow }}
      </div>
      <div class="page">
        {{ frameLength }}
      </div>
      <i
        class="next iconfont iconright"
        v-visible="frameNow < frameLength && !isPlaying"
        @click="nextFrame"
      />
    </div>
    <div class="action-panel">
      <c-led-converter @change="onConversionChange" v-visible="!isPlaying">
        <div class="upload" @click="colorPickerVivisble = false">
          <i class="iconfont icontupian" />
          {{ $t("light.imageConverter") }}
        </div>
      </c-led-converter>
      <div class="rotation" @click="onRotate" v-visible="!isPlaying">
        <i class="iconfont iconxuanzhuan" />
        180° {{ $t("rotation") }}
      </div>
      <c-undo
        @undo="setFrames"
        :data="frames"
        v-visible="!isPlaying"
        :key="'undo' + profile.lightIndex"
      >
        <div class="undo">
          <i class="iconfont iconchehui" />
          {{ $t("undo") }}
        </div>
      </c-undo>
    </div>
    <div class="color-panel">
      <div class="slider-panel">
        <c-slider class="slider" :value="color" @input="onColorInput" />
        <c-color-picker v-model="color" :presetColor="presetColor" />
      </div>
      <div class="hex-color">
        HEX COLOR
        <span>#</span
        ><input type="text" :value="inputColor" @change="onColorInput" />
      </div>
    </div>
    <div class="buttons">
      <div class="button" @click="onBack">
        {{ $t("confirm") }} & {{ $t("back") }}
      </div>
      <c-profile-download
        class="button"
        :profile="profile.data"
        :fileName="profile.fileName"
        :version="profile.version"
        @click="onSave"
        v-if="false"
      >
        <i class="iconfont icondownload" />
        {{ $t("download") }}
      </c-profile-download>
      <div v-if="false" class="button" @click="onSave">
        <span v-visible="false">*</span>
        {{ $t("save") }}
        <span v-visible="!saved">*</span>
      </div>
      <div class="button" @click="buildGIF" v-if="false">
        <a-icon class="iconfont" type="loading" v-if="isBuildingGIF" />
        <i class="iconfont icondownload" v-else />
        GIF
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import html2canvas from "html2canvas";
import { deepCopy, download, speedList } from "@/utils";

export default {
  name: "Light",
  data() {
    return {
      isShiftDown: false,
      isPlaying: false,
      brightness: 5,
      speed: 4,
      frames: [],
      frameIndex: 0,
      color: "#8028f5",
      presetColor: "#8028f5",
      colorPickerVivisble: false,
      selectedIndexes: [],
      saved: true,
      isBuildingGIF: false,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState(["profile"]),
    frameNow() {
      return this.frameIndex + 1;
    },
    frameLength() {
      return this.frames.length;
    },
    maxFrameLength() {
      return this.profile.version === "r1" ? 60 : 300;
    },
    inputColor() {
      return this.color.replace("#", "");
    },
  },
  methods: {
    initLight() {
      const lightEffects = this.profile.data.lightEffects;
      const lightEffect = deepCopy(lightEffects[this.profile.lightIndex]);
      this.brightness = lightEffect.brightness.value;
      this.speed = lightEffect.speed.value;
      this.frames = lightEffect.frames;
      this.frameIndex = 0;
    },
    onLEDClick({ index }) {
      let newFrames = [...this.frames];
      newFrames[this.frameIndex].frameRGB[index] = this.color;
      this.selectedIndexes = [];
      this.setFrames(newFrames);
      this.presetColor = this.color;
    },
    onLEDClickRight({ index, solid }) {
      let newIndexes = [...this.selectedIndexes];
      const findIndex = newIndexes.findIndex((item) => item === index);
      if (findIndex > -1) {
        if (!solid) {
          newIndexes.splice(findIndex, 1);
        }
      } else {
        newIndexes = [...newIndexes, index];
      }
      this.selectedIndexes = newIndexes;
    },
    onLightIndexSelect(e) {
      this.onSave();
      this.$store.dispatch("profile/setLightIndex", e.target.value).then(() => {
        this.initLight();
      });
    },
    removeFrame() {
      let newFrames = [...this.frames];
      newFrames.splice(this.frameIndex, 1);
      this.frameIndex = this.frameIndex > 1 ? this.frameIndex - 1 : 0;
      this.setFrames(newFrames);
    },
    removeAllFrame() {
      this.$confirm({
        title: this.$t("light.removeAllConfirm", [this.frameLength - 1]),
        onOk: () => {
          let newFrames = [this.frames[this.frameIndex]];
          this.frameIndex = 0;
          this.setFrames(newFrames);
        },
        width: "8.4rem",
        okText: this.$t("yes"),
        cancelText: this.$t("cancel"),
        centered: true,
      });
    },
    addFrame() {
      let newFrames = [...this.frames];
      let frameRGB = [...newFrames[this.frameIndex].frameRGB];
      newFrames.splice(this.frameIndex, 0, { frameRGB });
      this.frameIndex = this.frameIndex + 1;
      this.setFrames(newFrames);
      this.$message.info(this.$t("light.addSuccess"));
    },
    changeFrame(page) {
      this.frameIndex = page - 1;
      this.selectedIndexes = [];
    },
    nextFrame() {
      this.frameIndex = this.frameIndex + 1;
      this.selectedIndexes = [];
    },
    prevFrame() {
      this.frameIndex = this.frameIndex - 1;
      this.selectedIndexes = [];
    },
    buildGIF() {
      this.isPlaying = false;
      this.isBuildingGIF = true;
      this.frameIndex = 0;
      const gif = new window.GIF({
        workers: 4,
        quality: 1,
        workerScript: "/gif.worker.js",
      });
      gif.on("finished", (file) => {
        download(file, this.profile.fileName + ".gif");
        this.isBuildingGIF = false;
      });
      this.buildImage(gif);
    },
    buildImage(gif) {
      this.$nextTick(() => {
        const leds = document.querySelector(".lights .leds");
        html2canvas(leds, {
          backgroundColor: "#2f3032",
          height: leds.offsetHeight,
          width: leds.offsetWidth,
        })
          .then((canvas) => {
            gif.addFrame(canvas, { delay: speedList[this.speed - 1] });
            if (this.frameNow < this.frameLength) {
              this.frameIndex = this.frameIndex + 1;
              this.buildImage(gif);
            } else {
              gif.render();
              this.frameIndex = 0;
            }
          })
          .catch(() => {
            this.isBuildingGIF = false;
          });
      });
    },
    onConversionChange({ RGB, frames }) {
      if (frames) {
        this.setFrames(frames.splice(0, this.maxFrameLength));
      } else {
        let newFrames = [...this.frames];
        newFrames.splice(this.frameIndex, 1, { frameRGB: RGB });
        this.selectedIndexes = [];
        this.setFrames(newFrames);
      }
      this.onSave();
    },
    onRotate() {
      let newFrames = [...this.frames];
      newFrames = newFrames.map((item) => {
        item.frameRGB.reverse();
        return item;
      });
      this.setFrames(newFrames);
    },
    onColorInput(e) {
      const color = e.hex ? e.hex : "#" + e.target.value;
      this.color = color.length === 7 ? color : "#000000";
    },
    setFrames(frames) {
      this.frames = frames;
      this.saved = false;
    },
    onKeydown(e) {
      const key = e.keyCode;
      if (key >= 37 && key <= 40) {
        e.preventDefault();
        switch (key) {
          case 37: // ←
            this.moveLED(-5, 200, (index) => index < 5);
            break;
          case 38: // ↑
            this.moveLED(-1, 5, (index) => index % 5 === 0);
            break;
          case 39: // →
            this.moveLED(5, -200, (index) => index > 194);
            break;
          case 40: // ↓
            this.moveLED(1, -5, (index) => (index + 1) % 5 === 0);
            break;

          default:
            break;
        }
      }
      if (key === 65 && e.ctrlKey) {
        if (this.selectedIndexes.length === 200) {
          this.selectedIndexes = [];
        } else {
          let selectedIndexes = [];
          for (let i = 0; i < 200; i++) {
            selectedIndexes.push(i);
          }
          this.selectedIndexes = selectedIndexes;
        }
      }
    },
    onKeyup() {
      // const key = e.keyCode;
    },
    moveLED(step, offset, filter) {
      let replaceIndex,
        colors = [],
        newIndexes = [...this.selectedIndexes].sort((a, b) => a - b),
        normalIndexs = [],
        otherIndexs = [],
        newFrames = [...this.frames],
        frameRGB = [...newFrames[this.frameIndex].frameRGB];
      if (!newIndexes.length) {
        for (let i = 0; i < 200; i++) {
          newIndexes.push(i);
        }
      }
      if (step > 0) {
        newIndexes.reverse();
      }
      otherIndexs = newIndexes.filter(filter);
      normalIndexs = newIndexes.filter((index) => !otherIndexs.includes(index));
      newIndexes = [];
      otherIndexs.map((index) => {
        colors[index] = frameRGB[index];
        frameRGB[index] = "#000000";
      });
      normalIndexs.map((index) => {
        replaceIndex = index + step;
        frameRGB[replaceIndex] = frameRGB[index];
        frameRGB[index] = "#000000";
        newIndexes.push(replaceIndex);
      });
      otherIndexs.map((index) => {
        replaceIndex = index + step + offset;
        frameRGB[replaceIndex] = colors[index];
        newIndexes.push(replaceIndex);
      });
      newFrames[this.frameIndex].frameRGB = frameRGB;
      this.selectedIndexes = this.selectedIndexes.length ? newIndexes : [];
      this.setFrames(newFrames);
    },
    onBack() {
      this.onSave();
      this.$router.push(this.$paths.index);
      // if (this.saved) {
      //   this.$router.push(this.$paths.index);
      // } else {
      //   this.$confirm({
      //     title: this.$t("light.backConfirm"),
      //     onOk: () => {
      //       this.onSave();
      //       this.$router.push(this.$paths.index);
      //     },
      //     onCancel: () => {
      //       this.$router.push(this.$paths.index);
      //     },
      //     width: "8.4rem",
      //     okText: this.$t("save"),
      //     cancelText: this.$t("cancel"),
      //     centered: true,
      //   });
      // }
    },
    onSave() {
      let lightEffects = this.profile.data.lightEffects;
      lightEffects[this.profile.lightIndex] = {
        speed: {
          index: 1,
          value: this.speed,
        },
        brightness: {
          index: 2,
          value: this.brightness,
        },
        frames: Array.from(this.frames, (item, index) => ({
          frameIndex: index + 1,
          frameRGB: item.frameRGB,
        })),
      };
      this.saved = true;
      return this.$store.dispatch("profile/setData", {
        ...this.profile.data,
        lightEffects,
      });
    },
  },
  mounted() {
    this.initLight();
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    this.onSave();
    document.removeEventListener("keydown", this.onKeydown);
  },
};
</script>

<style lang="scss" scoped>
.light {
  min-height: inherit;
  color: #ffffff;
  padding: 40px 0;

  &.disabled {
    user-select: none;
    pointer-events: none;
    cursor: wait;
  }

  .title {
    font-size: 20px;
    text-align: center;
    margin-bottom: 30px;
  }

  .play-panel {
    @include flex-center;
    margin-bottom: 10px;

    .paly,
    .stop {
      @include icon-hover;
      font-size: 64px;
    }
  }

  .control-panel {
    @include flex-center;
    width: 1443px;
    margin: 0 auto 25px auto;

    .left,
    .right {
      width: 50%;
      flex: auto;
    }

    .brightness,
    .speed {
      @include flex-center;
      font-size: 12px;
      flex: none;

      .iconfont {
        font-size: 26px;
        line-height: 1;
        color: #ffffff;
        margin-right: 0.2rem;
      }

      .slider {
        width: 233px;
        margin-left: 20px;
        margin-right: 30px;
      }
    }

    .speed {
      padding-right: 20px;
      .iconfont {
        font-size: 22px;
      }
    }
  }

  .light-panel {
    @include flex-center;
    margin-bottom: 20px;
    position: relative;

    .remove,
    .add {
      flex: auto;
      @include flex-center;
      position: absolute;
      top: 40%;

      i {
        font-size: 36px;
        color: $primary-color;
        background: #171717;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
        cursor: pointer;
      }

      span {
        font-size: 12px;
        padding: 0 10px;
        color: #ffffff;
        visibility: hidden;
        display: none;
      }

      &:hover span {
        visibility: visible;
      }
    }

    .remove {
      justify-content: flex-end;
      right: 50%;
      margin-right: 750px;

      .remove-hover {
        position: relative;
        @include flex-center;

        .close,
        .reset {
          width: 36px;
          height: 36px;
          @include flex-center;
          color: #ffffff;
          background: $primary-color;
          font-size: 22px;
          position: absolute;
          transform: scale(0.3);
          opacity: 0;
          transition: all 0.5s ease-in-out;
          transition-delay: 0.2s;
        }

        .reset {
          transition-delay: 0.4s;
          font-size: 24px;
        }

        .close {
          margin-top: -80px;
          transform: scale(1);
          opacity: 1;
          transition-delay: 0s;
        }

        .reset {
          margin-top: 80px;
          transform: scale(1);
          opacity: 1;
          transition-delay: 0.15s;
        }

        .iconminus-o {
          display: none;
        }
      }
    }

    .add {
      justify-content: flex-start;
      left: 50%;
      margin-left: 750px;

      i {
        @include icon-hover;
        flex: none;
      }
    }

    .lights {
      width: 1443px;
    }
  }

  .page-panel {
    @include flex-center;
    position: relative;
    margin-bottom: 40px;

    .page-slider {
      width: 180px;
    }

    .prev,
    .next {
      @include icon-hover;
      font-size: 36px;
      padding: 5px 10px;
      margin: 0 50px;
    }

    .page {
      width: 60px;
      text-align: center;
    }

    .page-now {
      width: 50px;
      text-align: center;
      position: absolute;
      left: 50%;
      margin-left: -25px;
      bottom: -15px;
      font-size: 12px;
    }
  }

  .action-panel {
    @include flex-center;
    margin-bottom: 30px;

    .rotation,
    .upload,
    .undo {
      @include flex-center;
      width: auto;
      height: 40px;
      padding: 0 20px;
      margin-left: 30px;
      font-size: 14px;
      color: $primary-color;
      border: 1px solid $primary-color;
      border-radius: 10px;
      cursor: pointer;

      i {
        font-size: 26px;
        margin-right: 10px;
      }
    }

    .upload {
      margin-left: 0px;

      i {
        font-size: 24px;
      }
    }
  }

  .color-panel {
    @include flex-center;
    flex-direction: column;
    margin-bottom: 50px;

    .slider-panel {
      @include flex-center;
      margin-bottom: 30px;
      position: relative;

      .slider {
        width: 600px;
        margin: 0 30px;
      }

      .color {
        position: absolute;
        right: -20px;
        width: 46px;
        height: 46px;
        border-radius: 50%;
        border: 1px solid $primary-color;
        transform: translateX(50%);
        transition: all 0.1s;
        cursor: pointer;

        &:hover {
          width: 50px;
          height: 50px;
        }
      }
    }

    .hex-color {
      font-size: 20px;

      span {
        color: $primary-color;
        margin: 0 5px 0 30px;
      }

      input {
        width: 110px;
        text-align: center;
        color: $primary-color;
        user-select: text;
        border: 1px solid $primary-color;
      }
    }
  }

  .buttons {
    @include flex-center;

    .button {
      @include button;
      width: 200px;
      margin: 0 50px;

      span {
        font-size: 24px;
        line-height: 12px;
      }
    }
  }
}
</style>

<style lang="scss">
.page-slider {
  padding: 3px 0;

  .ant-slider-rail {
    height: 4px;
    background: #ffffff !important;
  }
  .ant-slider-track {
    height: 4px;
  }

  .ant-slider-handle {
    margin-top: -5px;
  }
  .ant-slider-handle:focus,
  .ant-slider-handle:hover {
    margin-top: -6px;
  }
}
</style>
